import { Inject, Injectable, Optional } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "../../api.service";
import * as i2 from "@angular/common/http";
export class InfoService {
  portalPath;
  api;
  http;
  url = '/info';
  apiVersion;
  constructor(portalPath, api, http) {
    this.portalPath = portalPath;
    this.api = api;
    this.http = http;
    this.setUrl(this.url);
  }
  getFrontendVersions() {
    return this.http.get('assets/versions.json');
  }
  getInfo() {
    return this.api.get(this.url, {}, this.apiVersion);
  }
  setApiVersion(apiVersion) {
    this.apiVersion = apiVersion ?? this.apiVersion;
    return this;
  }
  setUrl(url) {
    if (url) {
      this.url = (this.portalPath || 'portal') + url;
    }
    return this;
  }
  static ɵfac = function InfoService_Factory(t) {
    return new (t || InfoService)(i0.ɵɵinject('portalPath', 8), i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HttpClient));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: InfoService,
    factory: InfoService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InfoService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: ['portalPath']
    }]
  }, {
    type: i1.ApiService
  }, {
    type: i2.HttpClient
  }], null);
})();
